export default "__VITE_ASSET__DMxxz$xe__"